import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire Users section
*/
function User() {
  return <Outlet />;
}

export default User;
